/* global axios */
import ApiClient from './ApiClient';

class UserPreferencesAPI extends ApiClient {
  constructor() {
    super('user_preferences', { accountScoped: true });
  }

  get({ key, resourceType, resourceId }) {
    return axios.get(this.url, {
      params: { key, resource_type: resourceType, resource_id: resourceId },
    });
  }

  set({ key, value, resourceType, resourceId }) {
    return axios.put(this.url, {
      key,
      value,
      resource_type: resourceType,
      resource_id: resourceId,
    });
  }
}

export default new UserPreferencesAPI();
